<template>
	<div class="router-list-container">
		
		<data-container>
			<template slot="controls">
				<search-field
					v-model="filters.keyword"
					@input="getList"
				></search-field>

				<div class="control-wrapper">

					<div class="controls">
						<SelectField
							class="select-box"
							placeholder="Filter"
							displayProp="country"
							valueProp="country"
							idProp="country"
							deselect
							:disabled="countryPartnerLoading"
							:items="countryPartnerList"
							v-model="filters.filterBy"
							@input="changeFilter"
						/>

						<custom-option
							class="option"
							:options="sortOptions"
							placeholder="Sort by"
							v-model="filters.sortBy"
							@input="changeSort"
						>
						</custom-option>
					</div>

					<div class="controls">
						<button
							class="_primary"
							@click="addRouter()"
						>
							+ Register Router
						</button>
						
						<button
							class="_deny"
							@click="deleteRouter(null)"
							:disabled="buttonLoading || !selected.length"
						>
							Delete
						</button>
					</div>
				</div>
			</template>
			<template
				slot="content"
				class="table-wrapper"
			>
				<custom-table
					:fields="fields"
					:items="routerList.data"
					:current-page="routerList.current_page"
					:items-per-page="filters.itemsPerPage"
					:total-count="routerList.total"
					:selected-items="selected"
					:is-loading="listLoading"
					@changePage="changePage($event)"
				>

				<template #created_at="{ item }">
					{{ item.created_at | dateFormatter }}
				</template>

					<template
						#actions="{item}"
					>
						<button
							class="_approve"
							@click="updateItem(item)"
						>
							Update
						</button>

                        <button
							class="_primary"
							@click="copyLink(item)"
						>
							Quick Access
						</button>
						<!-- <button
							class="_delete"
							@click="deleteRouter(item)"
						>
							Delete
						</button> -->

						<!-- <button
							class="_primary"
							@click="viewItem(item)"
						>
							View
						</button> -->

					</template>
				</custom-table>
			</template>
		</data-container>
	</div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import * as routerModule from '@/store/router/app.js'

import SelectField from '@/components/utils/SelectField'
import DataContainer from '@/components/layouts/DataContainer.vue'
import CustomTable from '@/components/utils/CustomTable.vue'
import SearchField from '@/components/utils/SearchField.vue'
import CustomOption from '@/components/utils/CustomOption.vue'

export default {
	data () {
		return {
			filters: {
				page: 1,
				keyword: '',
				filterBy: {
					country: ''
				},
				sortBy: null,
				totalCount: 200,
				itemsPerPage: 10
			},

			sortOptions: ['Latest', 'Oldest'],

			filterOptions: ['Online', 'Offline', 'For Activation'],

			fields: [
				{ name: 'id', text: 'Router ID' },
				{ name: 'name', text: 'Router Name' },
				{ name: 'mac_address', text: 'Router MAC Address' },
				{ name: 'ip', text: 'IP Address' },
				{ name: 'band_count', text: 'Bands' },
				{ name: 'client_name', text: 'Host Admin' },
				{ name: 'company_name', text: 'Company' },
				{ name: 'country', text: 'Country' },
				{ name: 'created_at', text: 'Date Registered' }
			]
		}
	},

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['router/']) {
			this.$store.registerModule('router', routerModule.default)
		}
	},

	async created () {
		await this.checkParams()
		// this.getPartnerCountryList()
		this.getList()
	},

	computed: {
		...mapFields('router', {
			routerList: 'routerList',
			buttonLoading: 'buttonLoading',
			listLoading: 'listLoading',
			selected: 'selected'
		}),

		...mapFields('global', {
			countryPartnerList: 'countryPartnerList',
			countryPartnerLoading: 'countryPartnerLoading'
		})
	},

	methods: {
		changeSort () {
			this.filters.page = 1
			this.getList()
		},

		changeFilter () {
			this.filters.page = 1
			this.getList()
		},

		formParams () {
			const {
				page,
				keyword,
				sortBy,
				filterBy,
				itemsPerPage
			} = this.filters
			const form = new FormData()

			form.append('page', page)

			if (keyword !== '') {
				form.append('keyword', keyword)
			}

			if (sortBy !== null) {
				const type = sortBy === 'Latest' ? 'DESC' : 'ASC'
				form.append('sort_type', type)
			}

			if (filterBy.country) {
				form.append('filter', filterBy.country)
			}

			if (itemsPerPage) {
				form.append('count', itemsPerPage)
			}

			return form
		},

		async deleteRouter (item = null) {
			const form = await this.formParams()
			if (item) {
				form.append('id', item.id)
			} else {
				form.append('id', this.selected.join())
			}

			this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
                modalDesc: 'Are you sure you want to delete router(s)?',
                storeAction: 'router/deleteRouter',
                storePayload: form
			})
		},

		changePage ({ currentPage, itemsPerPage }) {
			if (this.filters.page === currentPage) {
				this.filters.page = 1
			} else {
				this.filters.page = currentPage
			}

			this.filters.itemsPerPage = itemsPerPage

			this.getList()
		},

		async search () {
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.filters.page = 1
				this.getList()
			}, 500)
		},

		async getList () {
			const {
				page,
				keyword,
				sortBy,
				filterBy,
				itemsPerPage
			} = this.filters

			let api = `?page=${page}`
			const query = { page: page }

			if (keyword !== '') {
				api += `&keyword=${keyword}`
				query.keyword = keyword
			}

			if (sortBy !== null) {
				const type = sortBy === 'Latest' ? 'DESC' : 'ASC'
				api += `&sort_type=${type}`
				query.sort_type = type
			}

			if (filterBy.country) {
				api += `&filter=${filterBy.country}`
				query.country = filterBy.country
			}

			if (itemsPerPage) {
				api += `&count=${itemsPerPage}`

				if (itemsPerPage !== 10) {
					query.count = itemsPerPage
				}
			}

			await this.$store.dispatch('router/getRouterList', api)
			this.$router.push({ query })
		},

		updateItem (e) {
			this.$router.push(`/router/update/${e.id}`)
		},

		addRouter () {
			this.$router.push({ name: 'router-create' })
		},

		// getPartnerCountryList () {
		// 	this.$store.dispatch('global/getPartnerCountryList')
		// },

		async checkParams () {
			const {
				page,
				keyword,
				sort_type,
				country,
				count
			} = this.$route.query

			if (page) {
				this.filters.page = page
			}

			if (keyword) {
				this.filters.keyword = keyword
			}

			if (sort_type) {
				this.filters.sortBy = sort_type === 'ASC' ? 'Oldest' : 'Latest'
			}

			if (country) {
				this.filters.filterBy.country = country
			}

			if (count) {
				this.filters.itemsPerPage = parseInt(count)
			}
		},

        async copyLink (e) {
			// const routeData = this.$router.resolve({
			// 	name: 'quick-access',
			// 	params: { routerId: e.id }
			// })

			const el = document.createElement('textarea')
			el.value = `${process.env.VUE_APP_INSIGHT_URL}/quick-access/${e.id}`
			document.body.appendChild(el)
			el.select()
			document.execCommand('copy')
			document.body.removeChild(el)

			this.$store.commit('modal/toggleNotification', {
				notificationName: 'notification-banner',
				notificationDesc: 'Link copied!',
				notificationType: 'success'
			})
		}
	},

	components: {
		DataContainer,
		CustomTable,
		SearchField,
		CustomOption,
		SelectField
	}
}
</script>

<style lang="scss" scope>
.router-list-container {

	.actions {
		display: flex;
		flex-direction: column;
	}

	button {
		&._approve {
			min-width: 70px;

			&:not(:last-child) {
				margin-bottom: 5px;
			}
		}
	}

	.option {
		margin-right: 10px;
	}

	.data-container {
		.control-wrapper {
			flex: 1 1 auto;
			margin-top: 15px;
			width: 100%;
			padding: 0 20px;
			display: flex;
			justify-content: space-between;
			

			.controls {
				display: flex;
				justify-content: flex-end;

				.select-box {
					margin-right: 5px;

					ul li.option {
						margin: 0;
					}

					.select {
						border-color: #d0d0df;
						padding: 2px;

						input {
							padding: 5px 10px;

							&::placeholder {
								color: #777;
							}
						}
					}

					.arrow {
						border-color: #777;
						top: 10px;
					}

					.option-wrapper {
						margin-top: -8px;
					}
				}
			}
			
			button {
				margin-left: 10px;
			}

		}

		/deep/ .custom-table {
			th, td {
				&:nth-child(10) {
					width: 120px;
				}
			}
		}
		
		.content-section {			

			.id {
				width: 100px;
			}

			span.online {
				color: #2DC4B6;
			}

			span.offline {
				color: #FF5D5D;
			}

			.client_id {
				width: 80px;
			}

			.status {
				width: 100px;
			}

			.mac_address, .ip {
				width: 200px;
			}
		}
	}
}
</style>
